/**
 * The isolation-milling modules, fetched when a mill command asks for them.
 *
 * The same argument as `boardwork.ts`, for the other half of the board work.
 * Isolation, the mill file and the path sequencer are reached from three Block
 * commands and from nowhere else, and `cam/isolation.ts` was the last thing
 * holding `net/pour.ts` in the initial download — everything else that imports
 * pour had already moved out behind a command.
 *
 * The dialogs come with them. They are only ever opened by the same commands,
 * so splitting them off separately would buy a second request and nothing else.
 */

import type { OutputChoice } from './ui/isolation.ts';

let pending: Promise<CamWork> | null = null;

export interface CamWork {
  trackIsolation: typeof import('@sircad/core/cam/isolation.ts')['trackIsolation'];
  millFile: typeof import('@sircad/core/cam/mill.ts')['millFile'];
  MILL_SUFFIX: typeof import('@sircad/core/cam/mill.ts')['MILL_SUFFIX'];
  sequencePaths: typeof import('@sircad/core/cam/sequence.ts')['sequencePaths'];
  showIsolationDialog: typeof import('./ui/isolation.ts')['showIsolationDialog'];
  showIsolationOutputDialog: typeof import('./ui/isolation.ts')['showIsolationOutputDialog'];
  showSequenceDialog: typeof import('./ui/sequence.ts')['showSequenceDialog'];
}

export type { OutputChoice };

export function camwork(): Promise<CamWork> {
  pending ??= (async (): Promise<CamWork> => {
    const [isolation, mill, sequence, ui, seqUi] = await Promise.all([
      import('@sircad/core/cam/isolation.ts'),
      import('@sircad/core/cam/mill.ts'),
      import('@sircad/core/cam/sequence.ts'),
      import('./ui/isolation.ts'),
      import('./ui/sequence.ts'),
    ]);
    return {
      trackIsolation: isolation.trackIsolation,
      millFile: mill.millFile,
      MILL_SUFFIX: mill.MILL_SUFFIX,
      sequencePaths: sequence.sequencePaths,
      showIsolationDialog: ui.showIsolationDialog,
      showIsolationOutputDialog: ui.showIsolationOutputDialog,
      showSequenceDialog: seqUi.showSequenceDialog,
    };
  })();
  return pending;
}
